<div class="landing-header" *ngIf="!isMobile">
    <div class="row">
        <div class="col-7">
            <img src="assets/img/logo-ioh.png" class="logo-icon" (click)="backToHome()"/>
        </div>
        <div class="col-5 lang-wrapper">
            <span (click)="changeLang('en')" class="lang" [ngClass]="{ 'active' : currentLang === 'en' }">EN</span>
            |
            <span (click)="changeLang('id')" class="lang" [ngClass]="{ 'active' : currentLang === 'id' }">ID</span>
        </div>
    </div>
</div>
